// Shared reviews data. All entries are REAL, verified quotes from the property's
// first-party review page (https://westbridgehotels.com/review-us/) sourced during
// Phase 4 build. Do NOT paraphrase or invent. Never add self-serving JSON-LD
// AggregateRating/Review markup on our own hotel pages — Google's structured-data
// policy disallows it and it risks a manual action.

export const GOOGLE_WRITE_REVIEW_URL = "https://g.page/r/CftYIU9v4ifiEBE/review";
export const GOOGLE_READ_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=Westbridge+Inn+%26+Suites+117+N+18th+St+Centerville+IA+52544";

// Real guest reviews (5-star only, verified from the property's public review page).
export const REVIEWS = [
  {
    id: "brian",
    author: "Brian",
    location: "Des Moines, IA",
    body:
      "We were visiting family for Christmas so we mainly used the room for sleeping. The motel and neighborhood was quiet. We took a hot shower and got a great sleep — exactly what we needed.",
    headline: "Great place to spend the night.",
    stars: 5,
  },
  {
    id: "dan",
    author: "Dan",
    location: "Denver, CO",
    body:
      "Very accommodating check-in. Clean room, no smell, neatly made beds, all amenities I needed. Staff — Donny, Jeff, Kimberly — were professional and attentive. Would stay again in a heartbeat.",
    headline: "Clean hotel & wonderful experience.",
    stars: 5,
  },
  {
    id: "cathy",
    author: "Cathy",
    location: "Chippewa Falls, WI",
    body: "The stay was short in duration. It was a good place and the price was right.",
    headline: "Happy from Wisconsin.",
    stars: 5,
  },
  {
    id: "royals-fan",
    author: "Royals fan 1616",
    location: "Louisburg, KS",
    body:
      "Stayed here for two nights on business. Owner was very cordial and helpful in every way. Clean rooms and a nice indoor swimming pool. Close to anything one would need — most within walking distance.",
    headline: "Friendly atmosphere.",
    stars: 5,
  },
  {
    id: "julius-t",
    author: "Julius T.",
    location: "Verified guest",
    body:
      "This was the best one can think of in a small town like this. Very clean rooms, beddings to bathrooms. I will recommend this hotel to everyone who visits this city for any reason.",
    headline: "The best in a small town.",
    stars: 5,
  },
  {
    id: "joe-m",
    author: "Joe M.",
    location: "Verified guest",
    body:
      "We had a great experience! The staff was great, rooms clean, and we could bring our dog. I would highly recommend Westbridge Inn & Suites to people.",
    headline: "Great staff, dog-friendly.",
    stars: 5,
  },
  {
    id: "dorothy-v",
    author: "Dorothy V.",
    location: "Verified guest",
    body:
      "I was well-cared-for. I forgot my cell phone in the breakfast room and KB was extremely helpful in getting it back to me. Thanks!",
    headline: "Well cared-for.",
    stars: 5,
  },
  {
    id: "jacob-w",
    author: "Jacob W.",
    location: "Verified guest",
    body:
      "Best place I've stayed yet! Great staff — very clean and comfy and fancy too. Can't give you guys enough stars.",
    headline: "Best place I've stayed.",
    stars: 5,
  },
];

// Short pull-quotes for narrow strips (room detail, stay pages).
export const REVIEW_SNIPPETS = REVIEWS.map((r) => ({
  id: r.id,
  author: r.author,
  quote: r.headline.replace(/\.$/, ""),
  body: r.body,
}));
